module.exports = __webpack_public_path__ + "static/media/font.8e458637.svg";